import {
  CalendarToday,
  Check,
  EventAvailable,
  Inventory2Outlined,
  Lock,
  LockPerson,
  ThumbDownOffAltRounded,
  WarningAmber,
} from "@mui/icons-material";

export const status_icon = {
  1: {
    label: "Available",
    icon: <Check />,
    hideInDiagram: true,
    color: "green",
  },
  2: {
    label: "Occupìed",
    icon: <Inventory2Outlined />,
    color: "blue",
  },
  3: {
    label: "Reserved",
    icon: <CalendarToday />,
    color: "darkgrey",
  },
  4: {
    label: "Out of Service",
    icon: <WarningAmber />,
    color: "red",
  },
  5: {
    label: "Rented",
    icon: <EventAvailable />,
    color: "blue",
  },
  6: {
    label: "Declined",
    icon: <ThumbDownOffAltRounded />,
    color: "orange",
  },
};

export const access_icon = {
  1: {
    label: "Public",
    icon: null,
  },
  2: {
    label: "Restricted",
    icon: <LockPerson />,
  },
  3: {
    label: "Internal use",
    icon: <Lock />,
  },
};
